import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHighcharts from '../CommonComponents/Highcharts';
import LoadingChart from '../CommonComponents/LoadingChart';
import { createCustomPropType, isUuid, isNumeric } from '../../js/app/react/validators';

class DebtManagementChartView extends Component {
  componentDidMount() {
    const { hasChartData, dataIsOutdated, isPrint } = this.props;

    if ((!hasChartData || dataIsOutdated) && !isPrint) {
      const {
        clientId, fpId, getChartData, goalId, isPdf,
      } = this.props;
      getChartData(fpId, clientId, isPdf, goalId);
    }
  }

  render() {
    const { isPrint, chartData, hasLoaded } = this.props;

    return (
      <section>
        <div
          className="
          NewFinancialPlan_ProgressChart
          NewFinancialPlan_DebtManagementProgressChart"
        >
          <div
            className="
            chart
            NewFinancialPlan_DebtManagementProgressChart_BarChart"
          >
            {!hasLoaded && <LoadingChart />}
            {hasLoaded && (
              <ReactHighcharts
                autoResize
                className={
                  isPrint
                    ? 'debtManagement-chart-container-print'
                    : 'debtManagement-chart-container'
                }
                container="MobileDebtManagementChart"
                options={chartData}
              />
            )}
          </div>
        </div>
      </section>
    );
  }
}

DebtManagementChartView.defaultProps = {
  isPdf: false,
  isPrint: false,
};

DebtManagementChartView.propTypes = {
  chartData: PropTypes.shape({}).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  dataIsOutdated: PropTypes.bool.isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  getChartData: PropTypes.func.isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  hasChartData: PropTypes.bool.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  isPdf: PropTypes.bool,
  isPrint: PropTypes.bool,
};

export default DebtManagementChartView;
